import { useCallback, useEffect, useRef, useState } from "react";
const AffiliateDetails = () => {
  

  return (
    <>
      <div className="hk-pg-wrapper">
        <div className="hk-pg-body py-0">
          <div className="page-wrap">
            <div className="page-content ps-0">
              <div className="page-detail-wrap">
                <header className="page-header">
                  <div>
                    <div className="page-title">
                      <div>
                        <h2 className="mb-1">Affiliate Details</h2>
                        <p className="fs-13">Affiliate Name, emial etc. details.</p>
                      </div>
                    </div>
                  </div>
                  <div className="page-options-wrap">
                    <div className="v-separator d-lg-inline-block d-none"></div>
                   
                    <a className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover hk-navbar-togglable d-lg-inline-block d-none"
                      href="#" data-bs-toggle="tooltip" data-bs-placement="top" title=""
                      data-bs-original-title="Collapse">
                      <span className="btn-icon-wrap">
                        <span className="feather-icon"><i className="ri-arrow-up-s-line ri-lg"></i></span>
                        <span className="feather-icon d-none"><i className="ri-arrow-down-s-line ri-lg"></i></span>
                      </span>
                    </a>
                  </div>
                </header>
                <div className="page-body">
                  <div data-simplebar className="nicescroll-bar">
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="card">
                            <div className="table-responsive">
                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default AffiliateDetails